import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CwpNgFrameworkModule } from '@blk/cwp-ng-framework';
import { DzProgressSpinnerModule } from '@blk/daisy/core/loading';
import { DzButtonModule } from '@blk/daisy/elements/buttons';
import { DzRadioModule } from '@blk/daisy/elements/selection-controls';
import { DzCheckboxModule } from '@blk/daisy/elements/selection-controls';
import { AnalyticsModule } from '@ddt-web/analytics';
import { SharedModule } from '@ddt-web/common';
import { GenericDirectivesModule } from '@ddt-web/generic-utils';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

import { ModelFamiliesTableComponent } from './components/model-library/model-families-table/model-families-table.component';
import { ModelListContainerComponent } from './components/model-library/model-list-container/model-list-container.component';
import { ModelListTableComponent } from './components/model-library/model-list-table/model-list-table.component';
import { ModelsScreenerDialogSkeletonComponent } from './components/model-library/models-screener-dialog/models-screener-dialog-skeleton/models-screener-dialog-skeleton.component';
import { ModelsScreenerDialogComponent } from './components/model-library/models-screener-dialog/models-screener-dialog.component';
import { ModelsTabsContainerComponent } from './components/model-library/models-tabs-container/models-tabs-container.component';
import { PillsComponent } from './components/model-library/pills/pills.component';

@NgModule({
	imports: [
		CommonModule,
		SharedModule,
		AnalyticsModule,
		RouterModule,
		CwpNgFrameworkModule,
		NgxSkeletonLoaderModule,
		DzButtonModule,
		GenericDirectivesModule,
		DzProgressSpinnerModule,
		DzRadioModule,
		DzCheckboxModule
	],
	declarations: [
		ModelsScreenerDialogComponent,
		ModelsScreenerDialogSkeletonComponent,
		ModelFamiliesTableComponent,
		ModelListTableComponent,
		ModelListContainerComponent,
		PillsComponent,
		ModelsTabsContainerComponent
	],
	exports: [ModelsTabsContainerComponent, ModelsScreenerDialogComponent, ModelListContainerComponent, PillsComponent]
})
export class ModelsScreenerModule { }
